import WidgetOverview from './WidgetOverview'

const ROUTES = [
  WidgetOverview
]

export default ROUTES
